import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width:100%;
  height:100%;
  padding: 0.5rem;
  flex-direction: column;
`;
export const Search = styled.div`
  display: flex;
  width:100%;
  height:2.5rem;
  border-radius: 6px;
  padding: 0.5rem;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  background-color: #f5f5f5;
  border: 1px solid #f5f5f5;

  input{
    outline: none;
    border: none;
    width: 100%;
    background-color: transparent;
    font-size: 15px;
    color: #4a4a4a;
  }
`;
export const Content = styled.div`
  position: relative;
  display: flex;
  width:100%;
  height:100%;
  flex-direction: column;
  margin-top: 1rem;
`;

export const ListUsers = styled.ul`
  position: absolute;
  display: flex;
  width:100%;
  max-height: 100%;
  flex-direction: column;

  overflow: scroll;
  padding: 0.5rem 0;

  gap: 0.5rem;

  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
`;